import { render, staticRenderFns } from "./modulelist.vue?vue&type=template&id=94519a44&scoped=true"
import script from "./modulelist.vue?vue&type=script&lang=js"
export * from "./modulelist.vue?vue&type=script&lang=js"
import style0 from "./modulelist.vue?vue&type=style&index=0&id=94519a44&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94519a44",
  null
  
)

export default component.exports